export const voiceflowConfig = {
  defaultProjectId: '68495622a24e4762dae0fece',
  adidasProjectId: '686fbadc664c076368411663',
  lorealProjectId: '686fbadc664c076368411663',
  siamoNoiProjectId: '6865754f0ebdcd0887aa9193',
  rennaiProjectId: '686e913de47e6a78263ba021',
} as const
